import * as React from 'react';
import { connect, Dispatch } from 'react-redux';
import { Field, InjectedFormProps, reduxForm } from 'redux-form';
import Grid from '@material-ui/core/Grid/Grid';

import Layout from '../Layout/Layout';
import Title from '../shared/Title/Title';
import { FETCH_USER_INFO } from '../../ducks/actions';
import { required } from '../shared/Forms/validations';

interface AdminProps {
  submitUserEmail: (email: string) => void;
}

const Admin = ({ submitUserEmail }: AdminProps) => (
  <Layout>
    <div>
      <Title text="Admin page" />
      <span>
        Please enter in the email or user_id of the user you would like to view the portal of:
        <AdminForm onSubmit={(data: { email: string }) => submitUserEmail(data.email)} />
      </span>
    </div>
  </Layout>
);

const mapDispatchToProps = (dispatch: Dispatch) => ({
  submitUserEmail: (email: string) => dispatch({ type: FETCH_USER_INFO, email }),
});
export default connect(null, mapDispatchToProps)(Admin);

const form = ({ handleSubmit, submitting }: InjectedFormProps) => (
  <form onSubmit={handleSubmit}>
    <Grid container justify="center">
      <Field name="email" type="text" component="input" label="Email" validate={required} />
    </Grid>
    <Grid container justify="center">
      <button type="submit" disabled={submitting}>
        Submit
      </button>
    </Grid>
  </form>
);

export const AdminForm = reduxForm({
  form: 'adminForm',
  enableReinitialize: true,
})(form);
